<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import BeneficiaryModal from "@/components/modals/beneficiary";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import UploadPopover from "@/components/widgets/upload-popover.vue";

export default {
    name: "ExtensionActivity",
    props: {
        allowAdd: {
            type: Boolean,
            default: true
        }
    },
    components: {
        DatePicker,
        BeneficiaryModal,
        MaskedInput,
        UploadPopover
    },
    data() {
        return {
            title: "Extension Activity",
            submitted: false,
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
            }),
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "activityName",
            sortDesc: false,
            fields: [
                {
                    key: "activityName",
                    sortable: true,
                },
                {
                    key: "proofOfTraining",
                    sortable: false,
                    label: "Proof of Training",
                },
                {
                    key: "totalParticipants",
                    sortable: true,
                    label: "No. of Trainees",
                },
                {
                    key: "duration",
                    sortable: true,
                    label: "Duration",
                },
                {
                    key: "lengthOfTraining",
                    sortable: true,
                    label: "Length of Training",
                },
                {
                    key: "actions",
                },
            ],
            form: {
                id: 0,
                activityName: "",
                activityDuration: "",
                totalParticipants: "",
                totalSurveyed: "",
                quality1P: "",
                quality2F: "",
                quality3S: "",
                quality4Vs: "",
                quality5E: "",
                isTraining: true,
                dateFrom: "",
                dateTo: "",
                lengthOfTraining: "",
                extensionProgramId: this.$route.params.id,
                beneficiaries: []
            },
            indexSelected: -1,
            tableBusy: false,
            activities: {},
            extensionId: 0,
            beneficiary: null,
            activityFileSettings: [],
            proofs: [],
            loadingFiles: true,
            trainingFileOpt: {
                type: "Extension Activity File",
                placement: "lefttop",
                folder: "Planning",
            },
        };
    },
    validations: {
        form: {
            activityName: { required },
            activityDuration: { required },
            totalParticipants: { required },
            totalSurveyed: { required },
            quality1P: { required },
            quality2F: { required },
            quality3S: { required },
            quality4Vs: { required },
            quality5E: { required },
            dateFrom: { required },
            dateTo: { required },
            lengthOfTraining: { required },
        },
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
    },
    async created(){
        await this.getActivityFileSettings();
    },
    methods: {
        async getActivityFileSettings(){
            await this.$store
                    .dispatch("extactfilesetting/GetAllExtensionActivityFile")
                    .then((res) => {
                        this.activityFileSettings = res.data;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
        },
        getData(row) {
            this.tableBusy = true;
            this.$store
                .dispatch("extensionactivity/GetExtensionActivityByEP", row.id)
                .then((res) => {
                    this.tableBusy = false;
                    res.data.forEach(async (item) => {
                        item.fromDisplay = this.formatDate(
                            new Date(item.dateFrom)
                        );
                        item.toDisplay = this.formatDate(new Date(item.dateTo));
                        if (item.activityDuration == 0) {
                            item.duration = "Less than 8 hrs";
                        } else if (item.activityDuration == 1) {
                            item.duration = "8 hrs or 1 day";
                        } else if (item.activityDuration == 2) {
                            item.duration = "2 days";
                        } else if (item.activityDuration == 3) {
                            item.duration = "3 to 4 days";
                        } else if (item.activityDuration == 4) {
                            item.duration = "5 days or more";
                        } else {
                            item.duration = "Not set";
                        }
                        item.beneficiaries = [];
                        item.beneficiaryNames = '';
                        item.beneficiaryLoading = false;
                    });
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
            this.extensionId = row.id;
            this.title = row.extensionName + " Activities";
            this.activities = cloneDeep(row);
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addEP() {
            this.onReset();
            this.modalTitle = "Create New Extension Activity";
            this.$bvModal.show("extension-activity-modal");
        },
        onCreate() {
            this.submitted = true;
            this.$v.$touch();
            var data = cloneDeep(this.form);
            data.dateFrom = this.getDate(this.form.dateFrom);
            data.dateTo = this.getDate(this.form.dateTo);
            data.extensionProgramId = this.extensionId;
            if (this.$v.$invalid) {
                return;
            } else {
                if (this.form.id > 0) {
                    this.$store
                        .dispatch(
                            "extensionactivity/UpdateExtensionActivity",
                            data
                        )
                        .then((res) => {
                            res.data.fromDisplay = this.formatDate(
                                this.form.dateFrom
                            );
                            res.data.toDisplay = this.formatDate(
                                this.form.dateTo
                            );
                            this.tableData.splice(this.indexSelected, 1, res.data);
                            this.saveBeneficiary(this.form.id, this.form.beneficiaries)
                            this.$bvModal.hide("extension-activity-modal");
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                } else {
                    this.$store
                        .dispatch(
                            "extensionactivity/CreateExtensionActivity",
                            data
                        )
                        .then((res) => {
                            res.data.fromDisplay = this.formatDate(this.form.dateFrom);
                            res.data.toDisplay = this.formatDate(this.form.dateTo);
                            res.data.beneficiary = this.beneficiary
                            if (res.data.activityDuration == 0) {
                                res.data.duration = "Less than 8 hrs";
                            } else if (res.data.activityDuration == 1) {
                                res.data.duration = "8 hrs or 1 day";
                            } else if (res.data.activityDuration == 2) {
                                res.data.duration = "2 days";
                            } else if (res.data.activityDuration == 3) {
                                res.data.duration = "3 to 4 days";
                            } else if (res.data.activityDuration == 4) {
                                res.data.duration = "5 days or more";
                            } else {
                                res.data.duration = "Not set";
                            }
                            this.tableData.push(res.data);
                            this.saveBeneficiary(res.data.id, this.form.beneficiaries)
                            this.$bvModal.hide("extension-activity-modal");
                            this.showToast("Successfully created!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
                this.submitted = false;
            }
        },
        onReset() {
            this.form = {
                id: 0,
                activityName: this.activities.extensionName,
                activityDuration: "",
                totalParticipants: "",
                totalSurveyed: "",
                quality1P: "",
                quality2F: "",
                quality3S: "",
                quality4Vs: "",
                quality5E: "",
                isTraining: true,
                dateFrom: new Date(this.activities.dateFrom),
                dateTo: new Date(this.activities.dateTo),
                beneficiaries: [],
                extensionProgramId: this.$route.params.id,
            };
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.form.quality1P = props.item.quality1P.toString();
            this.form.quality2F = props.item.quality2F.toString();
            this.form.quality3S = props.item.quality3S.toString();
            this.form.quality4Vs = props.item.quality4Vs.toString();
            this.form.quality5E = props.item.quality5E.toString();
            this.form.activityDuration = props.item.activityDuration.toString();
            this.form.totalParticipants = props.item.totalParticipants.toString();
            this.form.totalSurveyed = props.item.totalSurveyed.toString();
            this.form.lengthOfTraining = props.item.lengthOfTraining.toString();
            this.form.dateFrom = new Date(props.item.dateFrom);
            this.form.dateTo = new Date(props.item.dateTo);
            this.indexSelected = this.tableData.indexOf(props.item);
            this.modalTitle = "Update Extension Activity";
            this.$bvModal.show("extension-activity-modal");
            this.getBeneficiaries(props.item, 'form')
        },
        hideModal() {
            this.$bvModal.hide("extension-activity-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch(
                            "extensionactivity/DeleteExtensionActivity",
                            props.item.id
                        )
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        getBeneficiary() {
            this.$bvModal.show("beneficiary-modal");
        },
        dropData(data) {
            var modalData = cloneDeep(data);
            this.form.beneficiaries.push(modalData);
        },
        closeModal(){
            this.$emit('close');
        },
        calculateWeight(){
            let noOfTrainess = this.form.totalParticipants ? parseFloat(this.form.totalParticipants) : 0;
            let duration = 0;
            if (this.form.activityDuration == 0) {
                duration = 0.5;
            } else if (this.form.activityDuration == 1) {
                duration = 1
            } else if (this.form.activityDuration == 2) {
                duration = 1.25;
            } else if (this.form.activityDuration == 3) {
                duration = 1.5;
            } else if (this.form.activityDuration == 4) {
                duration = 2;
            } else {
                duration = 0;
            }
            let total = noOfTrainess * duration;
            this.form.lengthOfTraining = total;
        },
        async addSettingToProof(id){
            for await(const item of this.activityFileSettings){
                let data = {
                    extensionActivityId: id,
                    name: item.name,
                    description: item.description,
                }
                await this.$store.dispatch("proofoftraining/CreateExtensionActivityFile", data).then((res) => {
                    this.proofs.push(res.data);
                });
            }
        },
        async getActivityFiles(){
            for await(const item of this.proofs){
                await this.$store
                    .dispatch("filemanager/GetFiles", {id: item.id, type: this.trainingFileOpt.type})
                    .then((res) => {
                        item.files = res.data;
                    })
                    .catch(() => {
                        item.files = []
                        this.showToast('Something went wrong! - getting extension activity files', "error");
                    });
            }
        },
        showProof(props) {
            this.modalTitle = 'Proof of Activity'
            this.$bvModal.show("proof-modal");
            this.getProofs(props.id);
        },
        async getProofs(id) {
            this.loadingFiles = true;
            this.proofs = [];
            await this.$store.dispatch("proofoftraining/GetExtensionActivityFileByActivity", id).then((res) => {
                res.data.map((item) => {
                    item.files = [];
                    item.addFile = false;
                })
                this.proofs = res.data;
            });
            if (this.proofs.length == 0) {
                await this.addSettingToProof(id);
            }else{
                await this.getActivityFiles();
            }
            this.loadingFiles = false;
        },
        openDocument(x){
            this.readFile(x.id)
        },
        removeFile(id, parentId){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.proofs.findIndex(item => item.id == parentId);
                            let yIndex = this.proofs[index].files.findIndex(item => item.id == id);
                            this.proofs[index].files.splice(yIndex, 1);
                            this.showToast('Successfully removed!', "success");
                        })
                        .catch(() => {
                            this.showToast('Cannot be removed!', "error");
                        });
                }
            });
        },
        async uploadedActivityFile(response, id){
            var index = this.proofs.findIndex(x => x.id == id);
            await this.$nextTick();
            await this.wait(1000);
            this.proofs[index].files.push(response);
        },
        getDetails(row){
            row.toggleDetails();
            this.getBeneficiaries(row.item, 'view');
        },
        async getBeneficiaries(row, type){
            row.beneficiaryLoading = true;
            row.beneficiaryNames = '';
            let beneficiarieNames = ''
            let beneficiaries = [];
            await this.$store.dispatch("extensionactivity/GetActivityBeneficiary", row.id).then((res) => {
                res.data.map((item) => {
                    beneficiarieNames += item.beneficiary.beneficiaryName + ', ';
                    beneficiaries.push({...item.beneficiary, activityBeneficiaryId: item.id})
                })
                row.beneficiaryNames = beneficiarieNames.trim().slice(0, -1);
                if(type === 'view'){
                    row.beneficiaries = beneficiaries;
                }else{
                    this.form.beneficiaries = beneficiaries;
                }
            })
            .catch(() => {
                row.beneficiaries = [];
                this.showToast('Something went wrong! - getting beneficiaries', "error");
            });
            row.beneficiaryLoading = false;
        },
        removeBeneficiary(index){
            let data = cloneDeep(this.form.beneficiaries[index]);
            if(data.activityBeneficiaryId){
                this.$store.dispatch("extensionactivity/RemoveBeneficiary", data.activityBeneficiaryId).then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.form.beneficiaries.splice(index, 1);
                })
                .catch(() => {
                    this.showToast('Something went wrong! - removing beneficiary', "error");
                });

            }else{
                this.form.beneficiaries.splice(index, 1);
            }
        },
        saveBeneficiary(id, beneficiaries){
            let ben = [];
            beneficiaries.map((item) => {
                if(!item.activityBeneficiaryId){
                    ben.push(item.id);
                }
            })
            this.$store.dispatch("extensionactivity/AddMultipleBeneficiary", {id: id, array: ben});
        },
        inputHandler(event){
            const value = event.target.value + '' + event.key;
            if(parseFloat(value) > this.form.totalParticipants){
                event.preventDefault();
            }
        },
    },
};
</script>

<template>
    <div class="position-fixed" style="inset: 0; z-index: 1002;background:rgba(0,0,0,0.8);overflow-y:auto;">
        <b-modal
            id="proof-modal"
            :title="modalTitle"
            size="lg"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <div v-if="loadingFiles" style="min-height:200px;" class="d-flex align-items-center justify-content-center">
                <div class="d-flex justify-content-center">
                    <div class="spinner-grow text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
            <div v-if="!loadingFiles && proofs.length > 0">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Proof of Training</th>
                            <th>Files</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="proof of proofs">
                            <tr :key="`A${proof.id}`">
                                <td>{{proof.name}}</td>
                                <td>
                                    <div v-if="proof.files.length == 0">
                                        <button type="button" class="btn btn-sm btn-primary" :id="`upload-ext-activtiy-file${proof.id}`" @click="proof.addFile = true"><i class="bx bx-upload me-1"></i>Upload File</button>
                                        <upload-popover
                                            :option="trainingFileOpt"
                                            :sourceId="proof.id"
                                            @uploaded="uploadedActivityFile($event, proof.id)"
                                            :showPV="proof.addFile"
                                            @closePopover="proof.addFile = false"
                                            :dzId="`dropzone-ext-activtiy-file${proof.id}`"
                                            :pvId="`upload-ext-activtiy-file${proof.id}`"
                                        ></upload-popover>
                                    </div>
                                    <div v-else>
                                        <div v-for="file in proof.files" :key="file.id">
                                            <div :key="`${proof.id}${file.id}`" class="w-100 d-flex align-items-center">
                                                <a href="javascript:void(0);" class="w-100 d-flex align-items-center text-white" @click="openDocument(file)">
                                                    <i
                                                            v-if="file.fileType.includes('image')"
                                                            class="
                                                                mdi mdi-image font-size-15 me-1
                                                                text-purple
                                                            "
                                                        ></i>
                                                        <i
                                                            v-if="file.fileType.includes('application')"
                                                            class="
                                                                mdi mdi-file-pdf-outline font-size-15 me-1
                                                                text-danger
                                                            "
                                                        ></i>
                                                    {{file.description}}
                                                </a>
                                                <div style="width:20px" @click="removeFile(file.id, proof.id)" class="cursor-pointer"><i class="bx bx-trash text-danger font-bolder"></i></div>
                                            </div>
                                            <hr class="my-1" :key="`hr${proof.id}${file.id}`">
                                        </div>
                                        <a href="javascript:void(0);" v-if="proof.name.toLowerCase() === 'others'" :id="`upload-ext-activtiy-file${proof.id}`" @click="proof.addFile = true"><i class="bx bx-upload me-1"></i>Upload More</a>
                                        <upload-popover 
                                            v-if="proof.name.toLowerCase() === 'others'"
                                            :option="trainingFileOpt"
                                            :sourceId="proof.id"
                                            @uploaded="uploadedActivityFile($event, proof.id)"
                                            :showPV="proof.addFile"
                                            @closePopover="proof.addFile = false"
                                            :dzId="`dropzone-ext-activtiy-file${proof.id}`"
                                            :pvId="`upload-ext-activtiy-file${proof.id}`"
                                        ></upload-popover>
                                    </div>
                                </td>
                            </tr>
                            <tr :key="`B${proof.id}`">
                                <td colspan="100%">
                                    <textarea type="text" class="form-control" placeholder="Notes..." v-model="proof.notes" rows="1"></textarea>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </b-modal>
        <div class="p-5 mb-5">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div
                                class="
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                            >
                                <div>
                                    <h4 class="card-title m-0">
                                        Extension Activity List
                                    </h4>
                                    <small>{{ title }}</small>
                                </div>
                                <div class="d-flex">
                                    <button
                                        type="button"
                                        @click="addEP()"
                                        v-if="allowAdd"
                                        class="
                                            btn btn-md btn-info
                                            d-flex
                                            align-items-center
                                        "
                                    >
                                        <i class="bx bx-plus fs-6"></i>Create New
                                    </button>
                                    <button
                                        type="button"
                                        @click="closeModal"
                                        class="
                                            btn btn-link
                                            d-flex
                                            align-items-center
                                        "
                                    >
                                        <i class="bx bx-x fs-6 me-1"></i>Close
                                    </button>
                                </div>
                                <b-modal
                                    id="extension-activity-modal"
                                    :title="modalTitle"
                                    size="xl"
                                    title-class="font-18"
                                    hide-footer
                                    no-close-on-backdrop
                                >
                                    <form
                                        @submit.prevent="onCreate"
                                        class="needs-validation"
                                        ref="fcForm"
                                    >
                                        <div class="mb-3 row">
                                            <b-col sm="3">
                                                <label for="activityName"
                                                    >Title of Training
                                                </label>
                                                <textarea
                                                    autocomplete="off"
                                                    id="activityName"
                                                    rows="4"
                                                    v-model="form.activityName"
                                                    placeholder="Enter Title of Training..."
                                                    class="form-control"
                                                    :class="{'is-invalid': submitted && $v.form.activityName.$error}"
                                                ></textarea>
                                                <div v-if="submitted && $v.form.activityName.$error" class="invalid-feedback">
                                                    <span v-if="!$v.form.activityName.required">This value is required.</span>
                                                </div>
                                            </b-col>
                                            <b-col sm="3">
                                                <div class="mb-1">
                                                    <label for="dateFrom" class="mb-0">From</label>
                                                    <date-picker
                                                        v-model="form.dateFrom"
                                                        :first-day-of-week="1"
                                                        lang="en"
                                                        placeholder="Enter Date From..."
                                                        :class="{'is-invalid': submitted && $v.form.dateFrom.$error}"
                                                    ></date-picker>
                                                    <div
                                                        v-if="submitted && $v.form.dateFrom.$error"
                                                        class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.dateFrom.required">This value is required.</span>
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="dateTo" class="mb-0">To </label>
                                                    <date-picker
                                                        v-model="form.dateTo"
                                                        :first-day-of-week="1"
                                                        lang="en"
                                                        placeholder="Enter Date To..."
                                                        :class="{'is-invalid': submitted && $v.form.dateTo.$error}"
                                                    ></date-picker>
                                                    <div
                                                        v-if="submitted && $v.form.dateTo.$error"
                                                        class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.dateTo.required">This value is required.</span>
                                                    </div>
                                                </div>
                                            </b-col>
                                            
                                            <b-col sm="3">
                                                <div class="mb-1">
                                                    <label for="totalParticipants">No. of Trainees</label>
                                                    <masked-input
                                                        autocomplete="off"
                                                        id="totalParticipants"
                                                        type="text"
                                                        v-model="form.totalParticipants"
                                                        @change="calculateWeight"
                                                        placeholder="Enter No. of Trainees..."
                                                        class="form-control"
                                                        :class="{'is-invalid': submitted && $v.form.totalParticipants.$error}"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                    <div v-if="submitted && $v.form.totalParticipants.$error" class="invalid-feedback">
                                                        <span v-if="!$v.form.totalParticipants.required">This value is required.</span>
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="activityDuration">Duration</label>
                                                    <select
                                                        name="activityDuration"
                                                        class="form-select"
                                                        v-model="form.activityDuration"
                                                        @change="calculateWeight"
                                                    >
                                                        <option value="">
                                                            Select Duration
                                                        </option>
                                                        <option value="0">
                                                            Less than 8 hrs
                                                            <small class="text-warning">(0.5)</small>
                                                        </option>
                                                        <option value="1">
                                                            8 hrs or 1 day
                                                            <small class="text-warning">(1)</small>
                                                        </option>
                                                        <option value="2">
                                                            2 days
                                                            <small class="text-warning">(1.25)</small>
                                                        </option>
                                                        <option value="3">
                                                            3 to 4 days
                                                            <small class="text-warning">(1.5)</small>
                                                        </option>
                                                        <option value="4">
                                                            5 days or more
                                                            <small class="text-warning">(2)</small>
                                                        </option>
                                                    </select>
                                                    <div v-if="submitted && $v.form.activityDuration.$error" class="invalid-feedback">
                                                        <span v-if="!$v.form.activityDuration.required">This value is required.</span>
                                                    </div>
                                                </div>
                                            </b-col>
                                            <b-col sm="3">
                                                <div class="mb-1">
                                                    <label
                                                        for="totalSurveyed"
                                                        >No. of Trainees
                                                        Surveyed
                                                    </label>
                                                    <masked-input
                                                        autocomplete="off"
                                                        id="totalSurveyed"
                                                        type="text"
                                                        v-model="form.totalSurveyed"
                                                        placeholder="Enter No. of Trainees Surveyed..."
                                                        class="form-control"
                                                        :class="{'is-invalid': submitted && $v.form.totalSurveyed.$error}"
                                                        :mask="currencyMask"
                                                        @keypress="inputHandler($event)"
                                                    ></masked-input>
                                                    <div
                                                        v-if="
                                                            submitted &&
                                                            $v.form
                                                                .totalSurveyed
                                                                .$error
                                                        "
                                                        class="invalid-feedback"
                                                    >
                                                        <span
                                                            v-if="
                                                                !$v.form
                                                                    .totalSurveyed
                                                                    .required
                                                            "
                                                            >This value is
                                                            required.</span
                                                        >
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="lengthOfTraining">
                                                        Length of Training
                                                    </label>
                                                    <masked-input
                                                        autocomplete="off"
                                                        id="lengthOfTraining"
                                                        type="text"
                                                        :value="form.lengthOfTraining"
                                                        disabled
                                                        placeholder="Enter Length of Training..."
                                                        class="form-control"
                                                        :class="{'is-invalid': submitted && $v.form.lengthOfTraining.$error}"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                    <div
                                                        v-if="submitted && $v.form.lengthOfTraining.$error"
                                                        class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.lengthOfTraining.required">This value is required.</span>
                                                    </div>
                                                </div>
                                            </b-col>
                                        </div>
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Quality 1P</th>
                                                    <th>Quality 2F</th>
                                                    <th>Quality 3S</th>
                                                    <th>Quality 4Vs</th>
                                                    <th>Quality 5E</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <masked-input
                                                            autocomplete="off"
                                                            id="quality1P"
                                                            type="text"
                                                            v-model="form.quality1P"
                                                            placeholder="Enter Quality 1P..."
                                                            class="form-control"
                                                            :class="{
                                                                'is-invalid':
                                                                    submitted &&
                                                                    $v.form.quality1P
                                                                        .$error,
                                                            }"
                                                            :mask="currencyMask"
                                                        ></masked-input>
                                                        <div
                                                            v-if="
                                                                submitted &&
                                                                $v.form.quality1P.$error
                                                            "
                                                            class="invalid-feedback"
                                                        >
                                                            <span
                                                                v-if="
                                                                    !$v.form.quality1P
                                                                        .required
                                                                "
                                                                >This value is
                                                                required.</span
                                                            >
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <masked-input
                                                            autocomplete="off"
                                                            id="quality2F"
                                                            type="text"
                                                            v-model="form.quality2F"
                                                            placeholder="Enter Quality 2F..."
                                                            class="form-control"
                                                            :class="{
                                                                'is-invalid':
                                                                    submitted &&
                                                                    $v.form.quality2F
                                                                        .$error,
                                                            }"
                                                            :mask="currencyMask"
                                                        ></masked-input>
                                                        <div
                                                            v-if="
                                                                submitted &&
                                                                $v.form.quality2F.$error
                                                            "
                                                            class="invalid-feedback"
                                                        >
                                                            <span
                                                                v-if="
                                                                    !$v.form.quality2F
                                                                        .required
                                                                "
                                                                >This value is
                                                                required.</span
                                                            >
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <masked-input
                                                            autocomplete="off"
                                                            id="quality3S"
                                                            type="text"
                                                            v-model="form.quality3S"
                                                            placeholder="Enter Quality 3S..."
                                                            class="form-control"
                                                            :class="{
                                                                'is-invalid':
                                                                    submitted &&
                                                                    $v.form.quality3S
                                                                        .$error,
                                                            }"
                                                            :mask="currencyMask"
                                                        ></masked-input>
                                                        <div
                                                            v-if="
                                                                submitted &&
                                                                $v.form.quality3S.$error
                                                            "
                                                            class="invalid-feedback"
                                                        >
                                                            <span
                                                                v-if="
                                                                    !$v.form.quality3S
                                                                        .required
                                                                "
                                                                >This value is
                                                                required.</span
                                                            >
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <masked-input
                                                            autocomplete="off"
                                                            id="quality4Vs"
                                                            type="text"
                                                            v-model="form.quality4Vs"
                                                            placeholder="Enter Quality 4Vs..."
                                                            class="form-control"
                                                            :class="{
                                                                'is-invalid':
                                                                    submitted &&
                                                                    $v.form.quality4Vs
                                                                        .$error,
                                                            }"
                                                            :mask="currencyMask"
                                                        ></masked-input>
                                                        <div
                                                            v-if="
                                                                submitted &&
                                                                $v.form.quality4Vs
                                                                    .$error
                                                            "
                                                            class="invalid-feedback"
                                                        >
                                                            <span
                                                                v-if="
                                                                    !$v.form.quality4Vs
                                                                        .required
                                                                "
                                                                >This value is
                                                                required.</span
                                                            >
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <masked-input
                                                            autocomplete="off"
                                                            id="quality5E"
                                                            type="text"
                                                            v-model="form.quality5E"
                                                            placeholder="Enter Quality 5E..."
                                                            class="form-control"
                                                            :class="{
                                                                'is-invalid':
                                                                    submitted &&
                                                                    $v.form.quality5E
                                                                        .$error,
                                                            }"
                                                            :mask="currencyMask"
                                                        ></masked-input>
                                                        <div
                                                            v-if="
                                                                submitted &&
                                                                $v.form.quality5E.$error
                                                            "
                                                            class="invalid-feedback"
                                                        >
                                                            <span
                                                                v-if="
                                                                    !$v.form.quality5E
                                                                        .required
                                                                "
                                                                >This value is
                                                                required.</span
                                                            >
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="row mb-2 align-items-end">
                                            <b-col sm="12">
                                                <label for="beneficiaryId"
                                                    >Beneficiary
                                                </label>
                                                <b-input-group>
                                                    <template #append>
                                                        <b-button
                                                            @click="
                                                                getBeneficiary
                                                            "
                                                            variant="outline-info"
                                                            ><i
                                                                class="
                                                                    mdi
                                                                    mdi-clipboard-text-search-outline
                                                                "
                                                            ></i
                                                        ></b-button>
                                                    </template>
                                                    <div
                                                        class="form-control multiselect__tags success"
                                                        :class="{'border border-danger': submitted && form.beneficiaries.length == 0}"
                                                    >
                                                        <span style="color:rgba(255, 255, 255, 0.5)" v-if="form.beneficiaries.length == 0">Search Beneficiary...</span>
                                                        <div class="multiselect__tags-wrap">
                                                            <span
                                                                class="multiselect__tag"
                                                                v-for="(beneficiary, index) in form.beneficiaries"
                                                                :key="beneficiary.id"
                                                            >
                                                                <span>{{ beneficiary.beneficiaryName }}</span>
                                                                <i
                                                                    class="
                                                                        multiselect__tag-icon
                                                                    "
                                                                    @click="removeBeneficiary(index)"
                                                                ></i
                                                            ></span>
                                                        </div>
                                                    </div>
                                                </b-input-group>
                                                <div
                                                    v-if="submitted && form.beneficiaries.length == 0"
                                                    class="invalid-feedback"
                                                >
                                                    <span>This value is required.</span>
                                                </div>
                                            </b-col>
                                        </div>
                                        <!-- <div class="row mt-2">
                                            <div class="col">
                                                <input
                                                    autocomplete="off"
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    id="isTraining"
                                                    v-model="form.isTraining"
                                                />&nbsp;&nbsp;
                                                <label
                                                    class="form-check-label"
                                                    for="isTraining"
                                                    >Is Training?</label
                                                >
                                            </div>
                                        </div> -->
                                        <div class="modal-footer">
                                            <button
                                                type="submit"
                                                class="btn btn-primary"
                                            >
                                                Save changes
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-link"
                                                @click="hideModal"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </form>
                                </b-modal>
                            </div>
                            <div class="row mt-4">
                                <div class="col-sm-12 col-md-6">
                                    <div
                                        id="tickets-table_length"
                                        class="dataTables_length"
                                    >
                                        <label
                                            class="
                                                d-inline-flex
                                                align-items-center
                                            "
                                        >
                                            Show&nbsp;
                                            <b-form-select
                                                class="
                                                    form-select form-select-sm
                                                "
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                            ></b-form-select
                                            >&nbsp;entries
                                        </label>
                                    </div>
                                </div>
                                <!-- Search -->
                                <div class="col-sm-12 col-md-6">
                                    <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                    >
                                        <label
                                            class="
                                                d-inline-flex
                                                align-items-center
                                            "
                                        >
                                            Search:
                                            <b-form-input
                                                autocomplete="off"
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="
                                                    form-control form-control-sm
                                                    ms-2
                                                "
                                            ></b-form-input>
                                        </label>
                                    </div>
                                </div>
                                <!-- End search -->
                            </div>
                            <div class="table-responsive mb-0">
                                <b-table
                                    class="datatables"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    :busy="tableBusy"
                                    @filtered="onFiltered"
                                    bordered
                                    outlined
                                    hover
                                    striped
                                    show-empty
                                >
                                    <template #empty="scope">
                                        <div class="text-center">
                                            {{ scope.emptyText }}
                                        </div>
                                    </template>
                                    <template #table-busy>
                                        <div
                                            class="
                                                d-flex
                                                justify-content-center
                                                align-items-center
                                            "
                                        >
                                            <div
                                                class="preloader-component me-2"
                                            >
                                                <div class="status">
                                                    <div class="spinner-chase w-20px h-20px">
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>
                                    <template #cell(activityName)="row">
                                        <div>
                                            {{ row.value }}
                                        </div>
                                        <div>
                                            <a href="javascript:void(0);" class="text-green hover-underline" @click="getDetails(row)">View Extension Activity</a>
                                        </div>
                                    </template>
                                    <template #cell(proofOfTraining)="row">
                                        <button type="button" class="btn btn-primary btn-block btn-sm" @click="showProof(row.item)">Show Proof of Training</button>
                                    </template>
                                    <template #row-details="row">
                                        <div class="card">
                                            <div class="card-header d-flex align-items-center justify-content-between">
                                                <h5 class="card-title mb-0">
                                                    Extension Activity Details
                                                </h5>
                                                <a href="javascript:void(0)" class="text-secondary" @click="row.toggleDetails()"><i class="mdi mdi-close font-size-24"></i></a>
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="d-flex mb-3">
                                                            <div class="me-2">
                                                                <i class="mdi mdi-order-alphabetical-ascending font-size-24 text-success"></i>
                                                            </div>
                                                            <div>
                                                                <p class="mb-0 text-success">Title of Training:</p>
                                                                <p class="mb-0">{{row.item.activityName}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex mb-3">
                                                            <div class="me-2">
                                                                <i class="mdi mdi-label-multiple font-size-24 text-success"></i>
                                                            </div>
                                                            <div>
                                                                <p class="mb-0 text-success">Proof of Training:</p>
                                                                <button type="button" class="btn btn-primary btn-block btn-sm" @click="showProof(row.item)">Show Proof of Training</button>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex mb-3">
                                                            <div class="me-2">
                                                                <i class="mdi mdi-calendar font-size-24 text-success"></i>
                                                            </div>
                                                            <div>
                                                                <p class="mb-0 text-success">Date of Training:</p>
                                                                <p class="mb-0">From {{row.item.fromDisplay}} to {{row.item.toDisplay}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex">
                                                            <div class="me-2">
                                                                <i class="mdi mdi-account-circle font-size-24 text-success"></i>
                                                            </div>
                                                            <div>
                                                                <p class="mb-0 text-success">Beneficiary Name:</p>
                                                                <p class="mb-0">{{row.item.beneficiaryNames}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="d-flex mb-3">
                                                            <div class="me-2">
                                                                <i class="mdi mdi-account-switch font-size-24 text-success"></i>
                                                            </div>
                                                            <div>
                                                                <p class="mb-0 text-success">No. of Trainees:</p>
                                                                <p class="mb-0">{{row.item.totalParticipants}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex mb-3">
                                                            <div class="me-2">
                                                                <i class="mdi mdi-hours-24 font-size-24 text-success"></i>
                                                            </div>
                                                            <div>
                                                                <p class="mb-0 text-success">Duration:</p>
                                                                <p class="mb-0">{{row.item.duration}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex mb-3">
                                                            <div class="me-2">
                                                                <i class="mdi mdi-calendar-arrow-right font-size-24 text-success"></i>
                                                            </div>
                                                            <div>
                                                                <p class="mb-0 text-success">Length of Training:</p>
                                                                <p class="mb-0">{{row.item.lengthOfTraining}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex">
                                                            <div class="me-2">
                                                                <i class="mdi mdi-account-supervisor-circle font-size-24 text-success"></i>
                                                            </div>
                                                            <div>
                                                                <p class="mb-0 text-success">No of Trainees Surveyed:</p>
                                                                <p class="mb-0">{{row.item.totalSurveyed}}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <table class="table table-bordered table-striped">
                                                            <tbody>
                                                                <tr>
                                                                    <td class="text-success" style="width:100px;">Quality 1P</td>
                                                                    <td>{{row.item.quality1P}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-success" style="width:100px;">Quality 2F</td>
                                                                    <td>{{row.item.quality2F}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-success" style="width:100px;">Quality 3S</td>
                                                                    <td>{{row.item.quality3S}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-success" style="width:100px;">Quality 4Vs</td>
                                                                    <td>{{row.item.quality4Vs}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-success" style="width:100px;">Quality 5E</td>
                                                                    <td>{{row.item.quality5E}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template #cell(actions)="row">
                                        <div class="float-end">
                                            <b-dropdown
                                                id="dropdown-dropleft"
                                                right
                                                variant="link"
                                                toggle-class="text-decoration-none"
                                                menu-class="dropdown-menu-end"
                                                no-caret
                                            >
                                                <template #button-content>
                                                    <i
                                                        class="
                                                            fas
                                                            fa-ellipsis-v
                                                        "
                                                    ></i>
                                                </template>
                                                <b-dropdown-item
                                                    @click="updateItem(row)"
                                                    variant="secondary"
                                                    ><i
                                                        class="
                                                            mdi mdi-update
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >Edit</b-dropdown-item
                                                >
                                                <b-dropdown-item
                                                    @click="deleteItem(row)"
                                                    variant="danger"
                                                    ><i
                                                        class="
                                                            mdi mdi-trash-can
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >Delete</b-dropdown-item
                                                >
                                            </b-dropdown>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div
                                        class="
                                            dataTables_paginate
                                            paging_simple_numbers
                                            float-end
                                        "
                                    >
                                        <ul
                                            class="
                                                pagination pagination-rounded
                                                mb-0
                                            "
                                        >
                                            <!-- pagination -->
                                            <b-pagination
                                                v-model="currentPage"
                                                :total-rows="rows"
                                                :per-page="perPage"
                                            ></b-pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <beneficiary-modal v-on:dropData="dropData($event)"></beneficiary-modal>
    </div>
</template>